import React from 'react'
import { Link } from 'gatsby'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Socials from './socials'
import Year from './year'

export default function Footer() {
    return (
        <Container fluid className='bg-black'>
            <Container className='py-5'>
                <Row className='mb-3'>
                    <Col md='auto'>
                        <Link to='/'>
                            <img src='/svg/air-logo-white.svg' alt='' />
                        </Link>
                    </Col>
                    {/* SOCIAL ICON LINKS */}
                    <Col>
                        <Socials className='my-3 my-md-0 mx-md-5' />
                    </Col>
                    <Col md='auto' className='text-md-end text-white'>
                        <a href="https://inmusicbrands.com" rel='noreferrer' target='_blank'>
                            <img src='/svg/inmusic-logo-white.svg' alt='' />
                        </a>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-white d-flex flex-column flex-md-row justify-content-between'>
                        <div>
                            <p>© <Year /> inMusic, LLC. All Rights Reserved.</p>
                            <p>
                                <a href="https://www.plugivery.com/about/dealers/" target="_blank" rel="noreferrer">
                                    Dealers
                                </a>
                                <span>&nbsp; | &nbsp;</span>

                                <a href="https://support.airmusictech.com/en/support/home" target="_blank" rel="noreferrer">
                                    Support
                                </a>
                                <span>&nbsp; | &nbsp;</span>

                                <Link to='/downloads'>
                                    Downloads
                                </Link>
                                <span>&nbsp; | &nbsp;</span>

                                <a href="https://www.inmusicbrands.com/careers/" target="_blank" rel="noreferrer">
                                    Careers
                                </a>
                                <span>&nbsp; | &nbsp;</span>

                                <Link to='/privacy'>
                                    Privacy
                                </Link>
                                <span>&nbsp; | &nbsp;</span>

                                <Link to='/refund-policy'>
                                    Refund Policy
                                </Link>
                                <span>&nbsp; | &nbsp;</span>

                                <Link to='/terms-of-use'>
                                    Terms of Use
                                </Link>
                                <span>&nbsp; | &nbsp;</span>
                                
                                <Link to='/about-us'>
                                    About us
                                </Link>
                                <span>&nbsp; | &nbsp;</span>
                                <span id="teconsent" className='d-inline-block' />
                            </p>
                        </div>
                        <p>Part of the inMusic family of brands</p>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}